module.exports = __webpack_public_path__ + "img/tag_irv2.fe5e53b1.svg";